import GameList from '../components/GameList';
import type { GameManifest } from '@adgf/shared';
import { isPubliclyVisible } from '@adgf/shared';
import { gameRegistry } from '../games/registry';

// M1: Games are sourced from the client-side registry. Only publicly
// visible games (PUBLISHED / PAUSED) are shown in the public hall.
const VISIBLE_GAMES: GameManifest[] = gameRegistry
  .list()
  .filter((game) => isPubliclyVisible(game.status));

export default function HomePage() {
  return (
    <div>
      <section style={{ marginBottom: 32, textAlign: 'center' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: 8 }}>AI Daily Game Factory</h2>
        <p style={{ color: 'var(--color-text-muted)', maxWidth: 600, margin: '0 auto' }}>
          A global Web/PWA platform for AI-generated mini-games. Games are discovered, created,
          tested, and deployed through an automated AI pipeline.
        </p>
      </section>

      <section>
        <h3 style={{ fontSize: '1.25rem', marginBottom: 16 }}>Available Games</h3>
        <GameList games={VISIBLE_GAMES} />
      </section>

      <section style={{ marginTop: 48, padding: 24, background: 'var(--color-bg-secondary)', borderRadius: 'var(--radius)' }}>
        <h3 style={{ fontSize: '1.1rem', marginBottom: 12 }}>Platform Status (M3.2)</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
          <div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-primary)' }}>M3.2</div>
            <div style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>Current Stage</div>
          </div>
          <div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-primary)' }}>5</div>
            <div style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>Games</div>
          </div>
          <div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-primary)' }}>16</div>
            <div style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>Event Types</div>
          </div>
          <div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-primary)' }}>7</div>
            <div style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>Game States</div>
          </div>
        </div>
      </section>
    </div>
  );
}
